'use client'

import { Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { IMAGE_BASE_URL } from '../constants'

const ApplicationSection = () => {
  const translate = useTranslate('business.pro_integrations.application')

  return (
    <section className="pro-integrations__application" data-testid="pro-integrations-application">
      <h2
        className="pro-integrations__application-title"
        data-testid="pro-integrations-application-title"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: translate('title') }}
      />
      <div className="pro-integrations__application-inner">
        <div className="pro-integrations__application-image">
          <Image
            src={`${IMAGE_BASE_URL}/application-hvf-hero.png`}
            srcset={`${IMAGE_BASE_URL}/application-hvf-hero.png 1440w, ${IMAGE_BASE_URL}/application-hvf-hero@2x.png 2880w, ${IMAGE_BASE_URL}/application-hvf-hero@3x.png 4320w`}
            scaling={Image.Scaling.Cover}
            loading="lazy"
            testId="pro-integrations-application-image"
          />
        </div>
        <div className="pro-integrations__application-requirements">
          <h2
            className="pro-integrations__application-requirements-heading"
            data-testid="pro-integrations-application-requirements-heading"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: translate('heading') }}
          />
          <p
            className="pro-integrations__application-requirements-body"
            data-testid="pro-integrations-application-requirements-title"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: translate('requirements.title') }}
          />
          <p
            className="pro-integrations__application-requirements-body"
            data-testid="pro-integrations-application-requirements-description"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: translate('requirements.description') }}
          />
        </div>
      </div>
    </section>
  )
}

export default ApplicationSection
